<template>
  <div v-if="list && $is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])">
    <v-card-text style="height: 532px;">
      <v-layout row wrap>
        <v-flex xs6 pr-1>
          
          <v-text-field
            label="Name" 
            v-model="list.name" 
          ></v-text-field>

          <v-text-field
            label="UUID (public)"
            append-outer-icon="refresh" 
            @click:append-outer="generate_uuid"
            v-model="list.meta.uuid" 
            v-if="$is_privilege(['admin', 'root', 'developer', 'device_admin'])" 
          ></v-text-field>

          <v-autocomplete
            label="Category"
            item-text="name"
            item-value="id"
            :items="list_categories"
            v-model="list.type"
            v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
          ></v-autocomplete>

          <v-autocomplete
            label="List type"
            item-text="name"
            item-value="id"
            :items="list_types"
            v-model="list.cms_list_type_id"
            v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
          ></v-autocomplete>

          <v-autocomplete
            label="Parent List"
            item-text="name"
            item-value="id"
            :items="filtered_content_list"
            :clearable="true"
            v-model="list.meta.parent_list_id"
            v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
          >
            <template slot="append-outer" v-if="is_new">
              <v-btn small icon style="margin: 0;" 
                @click="set_active_as_parent"
              ><v-icon>star</v-icon></v-btn>
            </template>
          </v-autocomplete>

        </v-flex>
        <v-flex xs6 pl-1>
          <group-select v-model="list.groups"/>
          <!-- <json-editor v-model="list.meta"/> -->
          <notifiers-editor v-model="list.meta.notifiers" v-if="$is_admin()" />
        </v-flex>
      </v-layout>

    </v-card-text>
    <v-card-actions>
      <v-btn dark @click="delete_item" color="red" v-if="!list.meta.system">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat @click="run_notify" v-if="$is_admin() && list.meta.notify">Run notify</v-btn>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>

import JsonEditor from '@/components/JsonEditor'
import GroupSelect from '@/components/GroupSelect'
import NotifiersEditor from '@/components/NotifiersEditor'
import External from '@/models/external.js'
import { v4 as uuidv4 } from 'uuid';

export default {
  props: ['id'],
  components: {
    JsonEditor,
    GroupSelect,
    NotifiersEditor
  },
  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "cms:list:create" : "cms:list:" + this.id));
    return {
      ws_channel: ch,
      list: this.convert(ch.data),
      list_categories: [
        {"name": "Graphics", "id":"graphics"},
        {"name": "Team", "id":"team"},
        {"name": "Series", "id": "series"},
        {"name": "Sport", "id": "sport"},
        {"name": "Season", "id": "season"},
        {"name": "Poster", "id": "poster"},
        {"name": "Players", "id":"players"},
        {"name": "Event", "id":"event"},
        {"name": "Images", "id": "images"},
        {"name": "Graphics texts", "id": "graphics_texts"},
        {"name": "System", "id": "system"}

      ]
    };
  },
  watch: {
    'ws_channel.data': {
      handler(val) {
        this.list = this.convert(val)
      },
      deep: true
    }
  },
  computed: {
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    filtered_content_list () {
      var lists = _.filter(this.content_lists, (list) => { return list.id != this.id });
      lists = _.map(lists, (list) => { return {id: list.id, name: this.get_list_name (list)}; });
      return _.sortBy(lists, ["name",function(l) { return l.name.length; }]);
    },
    list_notifiers() {
      return External.notifiers;
    },
    list_notifier_types () {
      var notifier = External.get_notifier(this.list.meta.notify)
      if(typeof(notifier) == "object") {
        return External.get_cms_types(notifier) || [];
      }
      return [];
    },
    is_new() {
      return this.$route.path.includes("/new")
    }
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
    generate_uuid() {
      this.$set(this.list.meta, 'uuid', uuidv4());
    },
    set_active_as_parent() {
      if(this.$route.params.id != "default") {
        this.$set(this.list.meta, 'parent_list_id', parseInt(this.$route.params.id));
      }
    },
    run_notify() {
      this.ws_channel.push("notify", {list_id: this.list.id});
    },
    get_list_name (list) {
      return this.get_tree_name(list, "", []);
    },
    get_tree_name (list, acc, ids) {

      var parent = this.$store.state.cms_lists[list.meta.parent_list_id];
//      var parent = _.find(this.content_lists, (l) => { return l.id == list.meta.parent_list_id; });
      if(typeof(parent) == "undefined" || ids.indexOf(list.meta.parent_list_id) != -1) {
        return (acc != "" ? list.name + " / " + acc : list.name);
      } else {
        ids.push(parent.id);
        return this.get_tree_name(parent, (acc != "" ? list.name + " / " + acc : list.name), ids);
      }
    },
    convert (val) {
      return _.cloneDeep(val.list);
    },
    reset() {
      console.log(this.ws_channel);
      this.list = this.convert(this.ws_channel.data);
    },
    delete_item () {
      var self = this;
      this.ws_channel.push("delete", {list: this.list})
        .receive("ok", (msg) => {
          self.$message.success("List deleted!");
          this.$root.close_bottom_sheet()
        })
        .receive("error", (msg) => {
          console.log(msg);
          self.$message.warning("Cannot remove list");
        });
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var send_list = _.cloneDeep(this.list);

        if(!_.isEmpty(send_list.meta.uuid) && !/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(send_list.meta.uuid)) {
          self.$message.warning("UUID is invalid!");
          return;
        }

        this.ws_channel.push("save", {list: send_list})
          .receive("ok", (msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("List was created!");
            } else {
              self.$message.success("List was updated!");
            }
            if(close) this.$root.close_bottom_sheet()
          })
          .receive("error", (msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create list!");
            } else {
              self.$message.warning("Unable to update list!");
            }
          });
      }
    }
  }
}
</script>
